/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getHospitalManagers } from 'app/entities/hospital-manager/hospital-manager.reducer';
import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { getEntities as getOperationTheatres } from 'app/entities/operation-theatre/operation-theatre.reducer';
import { getEntities as getHospitalProcedures } from 'app/entities/hospital-procedure/hospital-procedure.reducer';
import { createEntity, getEntity, reset, updateEntity } from './surgical-appointment-attribute-type.reducer';

export const SurgicalAppointmentAttributeTypeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const hospitalManagers = useAppSelector(state => state.hospitalManager.entities);
  const hospitals = useAppSelector(state => state.hospital.entities);
  const operationTheatres = useAppSelector(state => state.operationTheatre.entities);
  const hospitalProcedures = useAppSelector(state => state.hospitalProcedure.entities);
  const surgicalAppointmentAttributeTypeEntity = useAppSelector(state => state.surgicalAppointmentAttributeType.entity);
  const loading = useAppSelector(state => state.surgicalAppointmentAttributeType.loading);
  const updating = useAppSelector(state => state.surgicalAppointmentAttributeType.updating);
  const updateSuccess = useAppSelector(state => state.surgicalAppointmentAttributeType.updateSuccess);

  const handleClose = () => {
    navigate(`/surgical-appointment-attribute-type${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getHospitalManagers({}));
    dispatch(getHospitals({}));
    dispatch(getOperationTheatres({}));
    dispatch(getHospitalProcedures({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.sortOrder !== undefined && typeof values.sortOrder !== 'number') {
      values.sortOrder = Number(values.sortOrder);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...surgicalAppointmentAttributeTypeEntity,
      ...values,
      addedBy: hospitalManagers.find(it => it.id.toString() === values.addedBy?.toString()),
      modifiedBy: hospitalManagers.find(it => it.id.toString() === values.modifiedBy?.toString()),
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
      theatre: operationTheatres.find(it => it.id.toString() === values.theatre?.toString()),
      procedure: hospitalProcedures.find(it => it.id.toString() === values.procedure?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...surgicalAppointmentAttributeTypeEntity,
          addedBy: surgicalAppointmentAttributeTypeEntity?.addedBy?.id,
          modifiedBy: surgicalAppointmentAttributeTypeEntity?.modifiedBy?.id,
          hospital: surgicalAppointmentAttributeTypeEntity?.hospital?.id,
          theatre: surgicalAppointmentAttributeTypeEntity?.theatre?.id,
          procedure: surgicalAppointmentAttributeTypeEntity?.procedure?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.surgicalAppointmentAttributeType.home.createOrEditLabel"
            data-cy="SurgicalAppointmentAttributeTypeCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.home.createOrEditLabel">
              Create or edit a SurgicalAppointmentAttributeType
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="surgical-appointment-attribute-type-id"
                  label={translate('tinyMedicRestApp.surgicalAppointmentAttributeType.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointmentAttributeType.name')}
                id="surgical-appointment-attribute-type-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointmentAttributeType.description')}
                id="surgical-appointment-attribute-type-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointmentAttributeType.format')}
                id="surgical-appointment-attribute-type-format"
                name="format"
                data-cy="format"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointmentAttributeType.sortOrder')}
                id="surgical-appointment-attribute-type-sortOrder"
                name="sortOrder"
                data-cy="sortOrder"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointmentAttributeType.retiredReason')}
                id="surgical-appointment-attribute-type-retiredReason"
                name="retiredReason"
                data-cy="retiredReason"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointmentAttributeType.retired')}
                id="surgical-appointment-attribute-type-retired"
                name="retired"
                data-cy="retired"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointmentAttributeType.active')}
                id="surgical-appointment-attribute-type-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointmentAttributeType.cursor')}
                id="surgical-appointment-attribute-type-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointmentAttributeType.lastupdated')}
                id="surgical-appointment-attribute-type-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointmentAttributeType.microSec')}
                id="surgical-appointment-attribute-type-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointmentAttributeType.timestampentry')}
                id="surgical-appointment-attribute-type-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                id="surgical-appointment-attribute-type-addedBy"
                name="addedBy"
                data-cy="addedBy"
                label={translate('tinyMedicRestApp.surgicalAppointmentAttributeType.addedBy')}
                type="select"
              >
                <option value="" key="0" />
                {hospitalManagers
                  ? hospitalManagers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="surgical-appointment-attribute-type-modifiedBy"
                name="modifiedBy"
                data-cy="modifiedBy"
                label={translate('tinyMedicRestApp.surgicalAppointmentAttributeType.modifiedBy')}
                type="select"
              >
                <option value="" key="0" />
                {hospitalManagers
                  ? hospitalManagers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="surgical-appointment-attribute-type-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.surgicalAppointmentAttributeType.hospital')}
                type="select"
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="surgical-appointment-attribute-type-theatre"
                name="theatre"
                data-cy="theatre"
                label={translate('tinyMedicRestApp.surgicalAppointmentAttributeType.theatre')}
                type="select"
              >
                <option value="" key="0" />
                {operationTheatres
                  ? operationTheatres.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="surgical-appointment-attribute-type-procedure"
                name="procedure"
                data-cy="procedure"
                label={translate('tinyMedicRestApp.surgicalAppointmentAttributeType.procedure')}
                type="select"
              >
                <option value="" key="0" />
                {hospitalProcedures
                  ? hospitalProcedures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/surgical-appointment-attribute-type"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SurgicalAppointmentAttributeTypeUpdate;
